import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-6 md:px-10 py-10 md:py-14">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-file-list-3-line text-base text-background-50"></i>
            </div>
            <span className="text-base font-semibold font-label text-foreground-950">
              Pandabuy<span className="text-primary-500">Sheet</span>
            </span>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-foreground-600">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hover:text-primary-600 transition-colors duration-200 cursor-pointer"
            >
              Pandabuy Sheet
            </a>
            <span className="text-foreground-300">|</span>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hover:text-primary-600 transition-colors duration-200 cursor-pointer"
            >
              Buy It Now
            </a>
            <span className="text-foreground-300">|</span>
            <Link
              to="/article/pandabuy-spreadsheet-guide"
              className="hover:text-primary-600 transition-colors duration-200"
            >
              Complete Guide
            </Link>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 text-center sm:text-left">
            &copy; {new Date().getFullYear()} PandabuySheet Hub. We curate and organize pandabuy spreadsheet data. We do not sell products directly.
          </p>
          <p className="text-xs text-foreground-400 text-center sm:text-right">
            Users must follow all applicable local regulations.
          </p>
        </div>
      </div>
    </footer>
  );
}